<template>
  <div>
    <div class="link-btn">
      <span @click="isShowConfig = true">
        选择跳转到的页面
        <i class="el-icon-arrow-down"></i>
      </span>
      <el-tag
        size="small"
        type="success"
        closable
        @close="closeTagFuc"
        v-show="jumpLink.remark"
      >
        {{ jumpTypeMap[jumpLink.type] }}
      </el-tag>
    </div>
    <el-dialog :visible.sync="isShowConfig">
      <el-form ref="form" label-width="100px" size="small">
        <el-form-item label="跳转类型">
          <el-radio-group v-model="jumpType" size="small">
            <el-radio-button
              :label="item"
              v-for="(item, index) in Object.keys(jumpTypeMap)"
              size="small"
              :key="index"
              >{{ jumpTypeMap[item] }}</el-radio-button
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="页面" v-show="jumpType == 1">
          <el-select v-model="jumpPage" placeholder="请选择">
            <el-option
              v-for="item in jumpPageList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" v-show="jumpType == 2">
          <div>
            <el-form-item label-width="10px">
              <el-button @click="openDialogFuc" type="primary" size="mini">
                <i class="el-icon-milk-tea"></i>添加{{
                  decorationShopType == 4 ? "服务" : "商品"
                }}</el-button
              >
              <!-- <el-button @click="clearGoodsList" size="small" circle>
                <i class="el-icon-delete" size="small"></i
              ></el-button> -->
            </el-form-item>
            <el-table :data="goodsListValue" style="width: 100%">
              <el-table-column type="index" width="50"> </el-table-column>
              <el-table-column
                prop="goodsId"
                :label="`${decorationShopType == 4 ? '服务' : '商品'}ID`"
                width="200"
              >
              </el-table-column>
              <el-table-column
                prop="goodsName"
                :label="`${decorationShopType == 4 ? '服务' : '商品'}名称`"
              >
              </el-table-column>
              <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                  <el-button
                    @click="deleteGoods(scope.$index)"
                    type="danger"
                    size="small"
                    circle
                  >
                    <i class="el-icon-delete" size="small"></i
                  ></el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <el-form-item label="" v-show="jumpType == 3">
          <el-select
            v-model="goodsCategoryId"
            :placeholder="`请选择${decorationShopType == 4 ? '服务' : '商品'}分类`"
          >
            <el-option
              v-for="item in classifyOptions"
              :key="item.goodsCategoryId"
              :label="item.categoryName"
              :value="item.goodsCategoryId"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowConfig = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
    <dialog-sel-goods-multiple
      ref="selGoods"
      @confirmSelGoods="confirmSelGoods"
      :limitNum="1"
    >
    </dialog-sel-goods-multiple>
  </div>
</template>

<script>
import dialogSelGoodsMultiple from "@/components/dialogSelGoodsMultiple";
import { mapState, mapActions } from "vuex";
import { comMixins } from "@/mixins/comMixins";
export default {
  mixins: [comMixins],
  name: "jumpConfig",
  props: {
    jumpLink: {
      type: Object,
      default: () => {
        return {
          type: 1, // 1小程序页面，2跳转商品页，3跳转商品分组
          remark: "",
        };
      },
    },
    jumpTypeLimit: {
      type: String,
      default: () => {
        return "total";
      },
    },
  },
  components: {
    dialogSelGoodsMultiple,
  },
  computed: {
    ...mapState({
      goodsCategorys: (state) => state.goodsCategorys,
    }),

    jumpTypeMap() {
      let listMap = {
        1: "跳转页面",
        2: `跳转${this.decorationShopType == 4 ? "服务" : "商品"}`,
        3: `跳转${this.decorationShopType == 4 ? "服务" : "商品"}分组`,
      };
      if (this.jumpTypeLimit == "onlyPage") {
        listMap = {
          1: "跳转页面",
        };
      }
      return listMap;
    },
    classifyOptions: {
      get() {
        let classifyOptions = [];
        if (this.goodsCategorys.length) {
          classifyOptions = JSON.parse(JSON.stringify(this.goodsCategorys));
        } else {
          this.updateGoodsCategorys();
        }
        return classifyOptions;
      },
    },
  },
  data() {
    return {
      goodsListValue: [],
      jumpType: 1,
      jumpPage: "",
      goodsCategoryId: "",
      isShowConfig: false,
    };
  },
  methods: {
    ...mapActions(["updateGoodsCategorys"]),
    closeTagFuc() {
      this.$emit("update:jumpLink", {
        type: 1,
        remark: "",
      });
    },
    openDialogFuc() {
      console.log("openDialog");
      let list = [];
      if (this.type == 2) {
        list = [remark];
      }
      this.$refs.selGoods.openDialog(list);
    },
    confirmSelGoods(list) {
      this.goodsListValue = list.map((val) => {
        return {
          goodsImage: val.goodsImage,
          goodsName: val.goodsName,
          goodsId: val.goodsId,
          goodsPrice: val.retailPrice,
          goodsUnit: val.unit,
        };
      });
    },
    deleteGoods(index) {
      console.log(index);
      this.goodsListValue.splice(index, 1);
    },
    clearGoodsList() {
      this.$confirm(`确定清空${this.decorationShopType == 4 ? "服务" : "商品"}吗?`, "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(({ value }) => {
          this.goodsListValue = [];
        })
        .catch(() => {});
    },
    confirm() {
      let remark = "";
      let remarktext = "";
      if (this.jumpType == 1) {
        remark = this.jumpPage;
        remarktext = this.jumpPageList[
          this.jumpPageList.findIndex((val) => {
            return val.value == this.jumpPage;
          })
        ].label;
      } else if (this.jumpType == 2) {
        console.log(this.goodsListValue);
        remark = this.goodsListValue[0].goodsId;
      } else if (this.jumpType == 3) {
        remark = this.goodsCategoryId;
      }
      this.$emit("update:jumpLink", {
        type: this.jumpType,
        remark,
        remarktext,
      });
      this.isShowConfig = false;
    },
  },
};
</script>

<style scoped lang="less">
.link-btn {
  color: #409eff;
  cursor: pointer;
}

.link-btn .el-icon-arrow-down,
.link-btn .el-tag {
  margin-right: 10px;
}
</style>
